// One named OperationalCheck: a name field plus its ordered list of
// ConditionRows. Mirrors reporting-hub's OperationalCheckItem.tsx.

import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import ConditionRow from './ConditionRow';

const OperationalCheckItem = ({ check, onChange, onRemove }) => {
  const updateCondition = (idx, patch) => {
    onChange({ ...check, conditions: check.conditions.map((c, i) => (i === idx ? { ...c, ...patch } : c)) });
  };

  const removeCondition = (idx) => {
    onChange({ ...check, conditions: check.conditions.filter((_, i) => i !== idx) });
  };

  const addCondition = () => {
    onChange({ ...check, conditions: [...check.conditions, { column: '', operator: '==', value: '', connector: 'AND' }] });
  };

  return (
    <div className="cr-card cr-card-compact mb-3">
      <div className="flex align-items-center gap-2 mb-2">
        <InputText
          value={check.name}
          onChange={(e) => onChange({ ...check, name: e.target.value })}
          placeholder="Check name"
          style={{ flex: 1, fontWeight: 600 }}
        />
        <Button icon="pi pi-trash" className="p-button-danger p-button-text p-button-sm" onClick={onRemove} aria-label="Remove check" />
      </div>
      <div>
        {check.conditions.map((condition, idx) => (
          <ConditionRow
            key={idx}
            condition={condition}
            isFirst={idx === 0}
            onChange={(patch) => updateCondition(idx, patch)}
            onRemove={() => removeCondition(idx)}
            canRemove={check.conditions.length > 1}
          />
        ))}
      </div>
      <Button label="+ Add condition" className="p-button-outlined p-button-sm" style={{ marginTop: '0.4rem' }} onClick={addCondition} />
    </div>
  );
};

export default OperationalCheckItem;
